import { usePostData } from "utils/ReactQueryHooks";

export const useUpdateEmailMarketing = () =>
    usePostData({
        url: "users/profile/update", 
        withToastSuccess: true,
        withToastError: true,
    });
